import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppHost, AppUrl, jtString, LegacyAppHost } from '@standardnotes/features';
import { c } from 'ttag';
const DotOrgNotice = () => {
    return (_jsx("div", { className: "z-modal flex h-30 w-full items-center bg-danger text-center text-info-contrast", children: _jsxs("div", { className: "w-full text-center text-xl font-bold", children: [jtString(c('B2.NavSharedUI.Warning').jt `${LegacyAppHost} is no longer maintained. Please switch to`), ' ', _jsx("a", { className: "underline", href: AppUrl, children: AppHost })] }) }));
};
export default DotOrgNotice;
